const { createInspirationTiles } = require('../shop/tiles/inspiration-tile-factory');

class SearchInspirationTileListController {
    constructor(settings, searchService) {
        this.settings = settings;
        this.searchService = searchService;
    }

    createTiles(result) {
        return {
            items: createInspirationTiles(result.items),
            totalRecordCount: result.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber) {
        return this.searchService.doSearchArticles(this.searchTerm, pageSize, pageNumber)
            .then(result => this.createTiles(result));
    }
}

SearchInspirationTileListController.$inject = ['Settings', 'SearchService'];

const searchInspirationTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<',
    },
    controller: SearchInspirationTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.settings.search.searchHeadingText + ' “' + $ctrl.searchTerm + '”'"
            page-number="$ctrl.pageNumber"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber)">

            <zero-result>
                <wow-search-zero-results></wow-search-zero-results>
            </zero-result>
        </wow-tile-list>
    `,
};

module.exports = {
    SearchInspirationTileListController,
    searchInspirationTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-inspiration-tile-list.component.js